import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const SynthesisView = ({ data }) => {
    if (!data) return <div className="p-4">Dati mancanti.</div>;

    // Handle both string content (API) and object content (Mock/Wrapper)
    const content = typeof data.content === 'string' ? data.content : JSON.stringify(data.content);

    return (
        <div className="h-full overflow-y-auto p-4">
            <div className="max-w-3xl mx-auto p-8 bg-white rounded-2xl shadow-sm border border-slate-100 mt-4">
                <div className="border-b border-slate-100 pb-4 mb-6">
                    <span className="bg-emerald-100 text-emerald-700 text-xs px-2 py-1 rounded font-bold uppercase tracking-wider">
                        Sintesi Generata
                    </span>
                    <h2 className="text-3xl font-bold text-slate-900 mt-3 leading-tight">
                        {data.title || 'Sintesi'}
                    </h2>
                </div>

                <div className="prose prose-slate prose-lg max-w-none">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {content}
                    </ReactMarkdown>
                </div>
            </div>
        </div>
    );
};

export default SynthesisView;
